var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSpeed = function SvgSpeed(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1824 12.5518C11.0544 12.6688 10.9404 12.7988 10.8404 12.9388C9.7944 14.4168 11.9264 16.1568 13.1654 14.8368C13.2834 14.7118 13.3874 14.5728 13.4764 14.4248L15.7214 10.1458C16.0274 9.63281 15.3684 9.09481 14.9264 9.49681L11.1824 12.5518",
    fill: "#B2B5B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9995 14.0001C1.9995 8.47715 6.47688 4.00011 11.9995 4.00011C17.5228 4.00011 21.9995 8.47682 21.9995 14.0001C21.9995 15.5569 21.6354 17.0667 20.9485 18.4451C20.7794 18.7846 20.4327 18.9991 20.0535 18.9991H3.9465C3.56701 18.9991 3.22022 18.7843 3.05118 18.4445C2.36429 17.0639 1.9995 15.5545 1.9995 14.0001ZM19.9995 14.0001C19.9995 9.58139 16.4182 6.00011 11.9995 6.00011C7.58142 6.00011 3.9995 9.58175 3.9995 14.0001C3.9995 15.0153 4.19447 16.0067 4.56719 16.9402L4.592 16.999H19.407L19.4328 16.941C19.7636 16.1126 19.9541 15.2371 19.9923 14.3382L19.9995 14.0001Z"
  })));
};
export default SvgSpeed;